import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    Label,
    ListGroup, ListGroupItem
} from 'reactstrap';
import { AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';

import { saveMenu, deleteMenu, publishMenu } from "../../../actions";
import { convertCheckBoxValueToBoolean } from '../../../utils/CommonUtils';
import ConfirmationScreen from '../settings/pos/ConfirmationScreen';
import PopoverCommon from './common/PopoverCommon';
import MenuPartsFooter from './common/MenuPartsFooter';
import AvailabilitySettings from './common/availability/AvailabilitySettings';
import MainInformation from './common/MainInformation';

class MenuScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentMenu: {
                id: -1,
                name: '',
                active: false,
                canBeDeleted: false,
                canBePublished: false,
                published: false,
                availableTimes: [],
                menuAvailableAllDay: true,
                disableNotes: false
            },
            stateAlreadyCopiedFromProps: false,
            activePopoverOpen: false,
            disableNotesPopoverOpen: false,
            tooltipOpen: false,
            publishTooltipOpen: false,
            additionalInfo: true,
            modalSize: false,
            arrowIcon: false,
            invalidSubmit: false,
            isDeleteBtnPressed: false,
            resetStateInterval: null,
            showErrorMsg: false
        }

        this.toggle = this.toggle.bind(this);
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.togglePublishTooltip = this.togglePublishTooltip.bind(this);
        this.changeState = this.changeState.bind(this);
        this.saveMenu = this.saveMenu.bind(this);
        this.deleteMenu = this.deleteMenu.bind(this);
        this.toggleActivePopover = this.toggleActivePopover.bind(this);
        this.toggleDisableNotesPopover = this.toggleDisableNotesPopover.bind(this);
        this.publishMenu = this.publishMenu.bind(this);
        this.showAdditionalInfo = this.showAdditionalInfo.bind(this);
        this.changeMenuOperationHours = this.changeMenuOperationHours.bind(this);
        this.toggleDeleteConfirmationWindow = this.toggleDeleteConfirmationWindow.bind(this);
        // Availability binds
        this.updatePrepTimesState = this.updatePrepTimesState.bind(this);
    }

    componentWillUnmount() {
        this.resetModalState();
    }

    componentDidMount() {
        if (this.props.menu.id) {
            this.copyStateFromProps();
        }
    }

    copyStateFromProps() {
        this.setState(
            {
                currentMenu: {
                    id: this.props.menu.id ? this.props.menu.id : -1,
                    name: this.props.menu.name,
                    active: this.props.menu.active,
                    canBeDeleted: this.props.menu.canBeDeleted,
                    canBePublished: this.props.menu.canBePublished,
                    published: this.props.menu.published,
                    availableTimes: this.props.menu.availableTimes,
                    menuAvailableAllDay: this.props.menu.menuAvailableAllDay,
                    disableNotes: this.props.menu.disableNotes
                },
                stateAlreadyCopiedFromProps: true
            }
        );
    }

    changeState({ target }) {
        if (target.value == true || target.value == 'true' || target.value == false || target.value == 'false') {
            this.setState({
                currentMenu: {
                    ...this.state.currentMenu,
                    [target.name]: convertCheckBoxValueToBoolean({ target })
                }
            });
        } else {
            this.setState({
                currentMenu: {
                    ...this.state.currentMenu,
                    [target.name]: target.value
                }
            });
        }
    }

    changeMenuOperationHours({ target }) {

        this.setState({
            currentMenu: {
                ...this.state.currentMenu,
                menuAvailableAllDay: target.value === 'always' ? true : false
            }
        });
    }

    updatePrepTimesState(prepTimes, showErrorMsg) {
        this.setState({
            ...this.state,
            currentMenu: {
                ...this.state.currentMenu,
                availableTimes: prepTimes
            },
            showErrorMsg: true
        });
    }

    resetModalState() {
        this.state.currentMenu.id = -1;
        this.state.currentMenu.name = "";
        this.state.currentMenu.active = false;
        this.state.currentMenu.availableTimes = [];
        this.state.currentMenu.canBeDeleted = false;
        this.state.currentMenu.canBePublished = false;
        this.state.currentMenu.published = false;
        this.state.currentMenu.menuAvailableAllDay = true;
        this.state.activePopoverOpen = false;
        this.state.tooltipOpen = false;
        this.state.publishTooltipOpen = false;
        this.state.showErrorMsg = false;
        this.state.stateAlreadyCopiedFromProps = false;
        this.state.additionalInfo = true;
        this.state.modalSize = false;
        this.state.arrowIcon = false;
        this.state.isDeleteBtnPressed = false;
    }

    showAdditionalInfo() {
        this.setState({
            modalSize: !this.state.modalSize
        });
    }

    saveMenu(publishMenuCallback) {
        let restaurantId = this.props.restaurantId;

        if (this.state.currentMenu.menuAvailableAllDay) {
            this.state.currentMenu.openingHours = [];
        }

        if (publishMenuCallback) {
            this.props.saveMenu(this.state.currentMenu, restaurantId, this.state.invalidSubmit, () => { }, publishMenuCallback);
            return;
        }

        this.props.saveMenu(this.state.currentMenu, restaurantId, this.state.invalidSubmit, () => {
            this.toggle(true);
        });
    }

    toggleDeleteConfirmationWindow() {
        this.setState({
            ...this.state,
            isDeleteBtnPressed: !this.state.isDeleteBtnPressed
        });
    }

    deleteMenu() {
        let restaurantId = this.props.restaurantId;
        this.props.deleteMenu(this.state.currentMenu, restaurantId);
        this.toggle();
    }

    publishMenu() {
        const publishMenuCallback = () => {
            let restaurantId = this.props.restaurantId;
            this.props.publishMenu(this.state.currentMenu, restaurantId);
            this.toggle(true);
        };

        this.saveMenu(publishMenuCallback);
    }

    toggle(saveOrPublish) {
        this.resetModalState();
        this.props.onToggle(this.state.currentMenu, saveOrPublish, 'menu');
    }

    toggleTooltip() {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    togglePublishTooltip() {
        this.setState({
            publishTooltipOpen: !this.state.publishTooltipOpen
        });
    }

    toggleActivePopover() {
        this.setState({
            activePopoverOpen: !this.state.activePopoverOpen
        });
    }

    renderActivePopover() {
        return (
            <PopoverCommon
                isOpen={this.state.activePopoverOpen}
                target="active"
                toggle={this.toggleActivePopover}
                textContent={i18n.t('screens:menuScreen.activePopover')}
            />
        );
    }

    toggleDisableNotesPopover() {
        this.setState({
            disableNotesPopoverOpen: !this.state.disableNotesPopoverOpen
        });
    }

    renderDisableNotesPopover() {
        return (
            <PopoverCommon
                isOpen={this.state.disableNotesPopoverOpen}
                target="disableNotes"
                toggle={this.toggleDisableNotesPopover}
                textContent={i18n.t('screens:menuScreen.disableNotesPopover')}
            />
        );
    }

    renderMenuForm() {
        const { activeLabel, marginLeft, cursorPointer, activeGroupStyle, listGroupItem } = styles;
        const { posSettings } = this.props;
        let colSize = 12;
        let arrowIcon = 'keyboard_arrow_right';
        let activeInfo = '';
        let iconColor = '#000';

        const deleteTooltipMsg =
            (this.state.currentMenu.id === undefined || this.state.currentMenu.id === -1)
                ? i18n.t('common:popovers.newItemMsg') : i18n.t('common:popovers.deleteMsg');

        if (this.state.modalSize) {
            colSize = 6;
            arrowIcon = 'keyboard_arrow_left';
            activeInfo = 'active';
            iconColor = '#0288D1';
        } else {
            colSize = 12;
            arrowIcon = 'keyboard_arrow_right';
        }

        return (
            <AvForm id={-1} className="modalForm" onValidSubmit={() => { this.saveMenu() }}>
                <fieldset style={{ display: 'contents' }} disabled={posSettings ? posSettings.type ? posSettings.type.id === 7 : false : false}>
                    <ModalHeader className="modalHeader" toggle={this.toggle}>{i18n.t('screens:menuScreen.heading')}</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col xs={this.state.modalSize ? 5 : colSize}>
                                <MainInformation
                                    nameValue={this.state.currentMenu.name}
                                    onChange={this.changeState}
                                />
                                <AvGroup id="activeCheckboxGroup" style={activeGroupStyle}>
                                    <span onClick={this.toggleActivePopover} id="active" style={cursorPointer} >
                                        <MaterialIcon icon="help" color="#ff990a" size={20} />
                                    </span>
                                    {this.renderActivePopover()}
                                    <Label for="active" style={activeLabel}>{i18n.t('common:buttons.active')}</Label>
                                    <AvInput type="checkbox" name="active"
                                        checked={!!this.state.currentMenu.active}
                                        onChange={this.changeState}
                                        style={marginLeft} />
                                </AvGroup>
                                <AvGroup id="activeCheckboxGroup" style={activeGroupStyle}>
                                    <span onClick={this.toggleDisableNotesPopover} id="disableNotes" style={cursorPointer} >
                                        <MaterialIcon icon="help" color="#ff990a" size={20} />
                                    </span>
                                    {this.renderDisableNotesPopover()}
                                    <Label for="disableNotes" style={activeLabel}>{i18n.t('screens:menuScreen.disableNotes')}</Label>
                                    <AvInput type="checkbox" name="disableNotes"
                                        checked={!!this.state.currentMenu.disableNotes}
                                        onChange={this.changeState}
                                        style={marginLeft} />
                                </AvGroup>
                                <ListGroup onClick={this.showAdditionalInfo} flush>
                                    <ListGroupItem style={listGroupItem} className={activeInfo}>
                                        {i18n.t('screens:menuConfigScreen.availabilityHours')}
                                        <span style={{ marginLeft: 'auto' }}><MaterialIcon icon={arrowIcon} color={iconColor} size={20} /></span>
                                    </ListGroupItem>
                                </ListGroup>
                            </Col>
                            <Col sm={this.state.modalSize ? 7 : 6} hidden={!this.state.modalSize}>
                                {this.renderAvailabilitySettings()}
                            </Col>
                        </Row>
                    </ModalBody>
                </fieldset>
                <MenuPartsFooter
                    styles={styles}
                    state={this.state}
                    isPublishDisabled={this.state.currentMenu.id === -1 ? true : false}
                    publishTooltipMsg={i18n.t('common:popovers.newItemMsg')}
                    onClickPublish={this.publishMenu}
                    publishTooltipToggle={this.togglePublishTooltip}
                    isDeleteDisabled={!this.state.currentMenu.canBeDeleted ? true : false}
                    deleteTooltipMsg={deleteTooltipMsg}
                    onClickDelete={this.toggleDeleteConfirmationWindow}
                    deleteTooltipToggle={this.toggleTooltip}
                />
            </AvForm>
        );
    }

    renderAvailabilitySettings() {

        return (
            <AvailabilitySettings
                screen={'menu'}
                preparationTimes={this.state.currentMenu.availableTimes}
                showErrorMsg={this.state.showErrorMsg}
                state={this.state}
                // Hardcoded value that diferentiates the two different types of the sub component's rendering
                availabilitySettings={true}
                itemAvailableAllDay={this.state.currentMenu.menuAvailableAllDay}
                updatePrepTimes={this.updatePrepTimesState}
                changeMenuOperationHours={this.changeMenuOperationHours}
            />
        );
    }

    renderConfirmationScreen() {
        let textData = {
            firstRow: i18n.t('screens:menuScreen.deleteMenuConfirmationText'),
            header: i18n.t('screens:menuScreen.deleteMenuHeader')
        }

        return (
            <ConfirmationScreen
                isOpen={this.state.isDeleteBtnPressed}
                onToggle={this.toggle}
                onSave={this.deleteMenu}
                hasDeleteBtn={true}
                message={textData}
            />
        );
    }

    render() {
        let modalSize;

        if (this.state.modalSize === true) {
            modalSize = 'lg';
        } else {
            modalSize = 'md';
        }

        return (
            <div>
                <Modal isOpen={this.props.isOpen} toggle={this.toggle} size={modalSize} className='menuScreen'>
                    {(!this.state.isDeleteBtnPressed) ? this.renderMenuForm() : this.renderConfirmationScreen()}
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return { posSettings: state.posSettings };
};

export default connect(mapStateToProps, { saveMenu, deleteMenu, publishMenu })(MenuScreen);

let styles = {
    activeLabel: {
        marginLeft: 6
    },
    marginLeft: {
        marginLeft: 10
    },
    cursorPointer: {
        cursor: 'pointer'
    },
    activeGroupStyle: {
        paddingLeft: '0.4rem',
        width: '100%'
    },
    listGroupItem: {
        display: 'flex',
        background: 'none',
        borderBottom: '1px solid #dee2e7',
        cursor: 'pointer',
        borderTop: 'none',
        paddingLeft: '0.2rem',
        paddingRight: 0,
        paddingTop: 0
    },
    spaceBetween: {
        paddingLeft: 4
    },
    menuAvailabilityRadioBtns: {
        marginLeft: 10,
        marginRight: 10
    },
    screenHeading: {
        display: 'flex',
        borderBottom: '1px solid rgb(222, 226, 230)',
        marginBottom: 20,
        marginLeft: -5,
        paddingLeft: 0
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/MenuScreen.js